module.exports = __webpack_public_path__ + "static/assets/61ab2c9b4fad15ad906d4e7ceae9b6ee.svg";